/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import Pipe = Models.Pipe;
    import IPipe = Application.Models.IPipe;
    
    /**
     * ConnectionRoom Controller class
     */
    export class ConnectionRoomController extends ConnectionRoomParentController {
        public static $name: string = "connectionRoomController";
        public static $inject: string[] = ['$scope', 
                                           'connectionRoomService',
                                           'ModalService',
                                           '$q',
                                           '$cookies',
                                           'stompService',
                                           '$timeout',
                                           'aclService',
                                           'messageTranslationsService',
                                           'userService',
                                           ];

        public static COOKIE_OPTIONS: ng.cookies.ICookiesOptions = {
            expires: Common.Utils.getCookieExpirationDate(),
            secure: location.protocol === 'https:',
        };
        private static SORTABLE_PIPES_ID: string = '#sortable-pipes';
        public userIsAdmin: boolean;
        private searchText: string;
        private timeoutSearch: ng.IPromise<void>;
        private stompService: Services.StompService;
        private $timeout: ng.ITimeoutService;
        private takeSubscription: Services.IEventSubscription;
        private dropSubscription: Services.IEventSubscription;

        /**
         * Constructor
         */
        constructor($scope: ng.IScope,
                    connectionRoomService: Services.ConnectionRoomService,
                    modalService: ngModal.IModalService,
                    qService: ng.IQService, $cookies: ng.cookies.ICookiesService,
                    stompService: Services.StompService,
                    $timeout: ng.ITimeoutService,
                    aclService: Services.AclService,
                    messageTranslationsService: Services.MessageTranslationsService,
                    userService: Services.UserService) {
            super($scope, connectionRoomService, modalService, qService, $cookies, aclService, messageTranslationsService, () => {
                this.matchedPipes = this.selectedConnectionRoom.pipes;
            });

            userService.loadCurrentUser().then((user: Models.IUser) => {
                this.userIsAdmin = user.authorities.some((auth: Models.IAuthority) => {
                    return auth.authority === 'ROLE_ADMIN';
                });
            });

            this.qService = qService;
            this.stompService = stompService;
            this.$timeout = $timeout;
            this.initSortableWatcher();
            this.takeSubscription = this.stompService.register(
                Models.FLEXO_COMPONENT, Models.TAKE_OPERATION, (flexEvent: Models.IFlexEvent) => {
                this.takeMessageReceived(flexEvent);
            });

            this.dropSubscription = this.stompService.register(
                Models.FLEXO_COMPONENT, Models.DROP_OPERATION, (flexEvent: Models.IFlexEvent) => {
                this.dropMessageReceived(flexEvent);
            });
            this.$scope.$on("$destroy", () => {
                if ($(ConnectionRoomController.SORTABLE_PIPES_ID).length) {
                    $(ConnectionRoomController.SORTABLE_PIPES_ID).off('stop.uk.sortable');
                }
                if (this.takeSubscription)
                    this.stompService.unregister(this.takeSubscription);
                if (this.dropSubscription)
                    this.stompService.unregister(this.dropSubscription);
            });
        }  

        public changeRoom(): void {
                this.searchText = "";
                this.matchedPipes = [];
                this.loadConnectionRooms().then(() => {
                    this.matchedPipes = this.selectedConnectionRoom.pipes;
                });
        };
        
        public initSortableWatcher(): void {
            this.$scope.$watch('crc.selectedConnectionRoom', (newValue: Models.IConnectionRoom, oldValue: Models.IConnectionRoom) => {
                if (newValue !== undefined && newValue !== oldValue) {
                    let cookieVal: string = Common.Utils.idFromHref(this.selectedConnectionRoom.href).toString();
                    this.$cookies.put(this.cookieKey, cookieVal, ConnectionRoomController.COOKIE_OPTIONS);
                    UIkit.sortable($(ConnectionRoomController.SORTABLE_PIPES_ID), {animation: "750"});
                    $(ConnectionRoomController.SORTABLE_PIPES_ID).on('stop.uk.sortable', 
                        (event: Object, sortableObject: Object, draggedElement: Object) => {
                            let pipeDivs: JQuery = $('#sortable-pipes').children();
                            let orderedPipes: number[] = new Array();
                            for (let i: number = 0; i < pipeDivs.length; i++) {
                                let pipeId: number = parseInt(pipeDivs[i].id.substr(pipeDivs[i].id.lastIndexOf('-') + 1), 10);
                                orderedPipes.push(pipeId);
                            }
                            this.connectionRoomService.reorderPipes(this.selectedConnectionRoom.href, orderedPipes);
                        });
                    this.checkUserCanWriteRoom( this.selectedConnectionRoom );
                }
            });
        }

        /**
         * Modal to delete a pipe
         */
        public deletePipeModal(pipe: Pipe): void {
            let self: Controllers.ConnectionRoomController = this;
            let desc: string = 'This action cannot be undone. ';
            let hasDest: boolean = false;
            desc += 'Encoder: [ ' + (pipe.sourceName ? pipe.sourceName : '') + ' ] Receivers: [ ';
            for (let dest of pipe.destinations) {
                desc += (dest.name ? dest.name : '') + ' ';
                if (dest.name) {
                    hasDest = true;
                }
            }
            desc += '].';

            if ((pipe.source === '' || pipe.sourceName === '') && !hasDest) {
                self.removePipe(pipe);
            } else {
                this.modalService.showModal({
                    templateUrl: Application.Controllers.ConfirmModalController.templateURL,
                    controller: Application.Controllers.ConfirmModalController.$name,
                    inputs: {
                        title: 'DELETE PIPE',
                        description: desc,
                        name: '',
                        type: 'warning',
                    },
                }).then((modal: ngModal.IModalObject) => {
                    let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ConfirmModalController.ID,
                                                        {bgclose: false, modal: false, keyboard: false});
                    modalElem.show();
                    modal.close.then((result: string) => {
                        modalElem.hide();
                        if (result) {
                            self.removePipe(pipe);
                        }
                    });
                    // clear search box
                    this.searchText = '';
                    this.searchAsType();
                });
            }
        }

        public isPipeEmpty(pipe: Models.Pipe): boolean {
            return pipe.source === "" || pipe.sourceName === "" || pipe.destinations[0].name === "";
        }

        /**
         * Play or pause pipe destination[index]
         */
        public changeStatus(pipe: Models.Pipe, index: number): ng.IPromise<Models.IPipe> {
            return this.connectionRoomService.changeStatus(pipe, index)
                .then((element: Models.IPipe) => {
                    this.updateSavedPipeInFrontendModel(element);
                    return element;
                })
                .catch((reason: ngCustom.IReason) => {
                    // restore previous value
                    pipe.destinations[index].status = !pipe.destinations[index].status;
                    this.messageTranslationsService.showPromiseError(reason);
                    return pipe;
                });
        }

        public addDestination(pipe: Models.Pipe, destination: string, index: number): ng.IPromise<Models.IPipe> {
            return this.connectionRoomService.addDestination(pipe, destination, index)
                .then((element: Models.IPipe) => {
                    this.updateSavedPipeInFrontendModel(element);
                    return element;
                })
                .catch((reason: ngCustom.IReason) => {
                    this.messageTranslationsService.showPromiseError(reason);
                    return pipe;
                });
        }

        public addSource(pipe: Models.Pipe, source: string): ng.IPromise<Models.IPipe> {
            return this.connectionRoomService.addSource(pipe, source)
                .then((element: Models.IPipe) => {
                    this.updateSavedPipeInFrontendModel(element);
                    return element;
                })
                .catch((reason: ngCustom.IReason) => {
                    this.messageTranslationsService.showPromiseError(reason);
                    return pipe;
                });
        }

        public searchAsType(): void {
            if (this.searchText !== undefined && this.searchText !== "") {
                this.$timeout.cancel(this.timeoutSearch);
                this.timeoutSearch = this.$timeout(() => {
                    this.applyFilter();
                }, 500);
            }
            else {
                this.chooseSelectedRoom(this.connectionRooms);
            }
        }

        public applyFilter(): void {
            if (this.searchText !== undefined && this.searchText !== "") {
                this.matchedPipes = this.selectedConnectionRoom.pipes.filter((pipe: Models.IPipe) => {
                    for (let destination of pipe.destinations) {
                        if (destination.name) {
                            if (destination.name.toLocaleLowerCase().indexOf(this.searchText.toLocaleLowerCase()) !== -1) {
                                return destination.name.toLocaleLowerCase().indexOf(this.searchText.toLocaleLowerCase()) !== -1;
                            }
                        }
                    }
                    if (pipe.sourceName) {
                        return pipe.sourceName.toLocaleLowerCase().indexOf(this.searchText.toLocaleLowerCase()) !== -1;
                    }
                    return false;
                });
            } else {
                this.matchedPipes = this.selectedConnectionRoom.pipes;
            }
        }

        public getLoadedStreamPipeById( streamPipeId: number ): IPipe {
            let pipes: IPipe[] = this.selectedConnectionRoom.pipes.filter( (pipe: IPipe  ) => {
                return pipe.destinations.some((dest: Models.IDestination) => {
                    if (dest.streamPipeHref) {
                        return Common.Utils.idFromHref(dest.streamPipeHref) === streamPipeId;
                    }
                });
            });

            return pipes.length > 0 ? pipes[0] : undefined;
        }

        private takeMessageReceived(flexEvent: Models.IFlexEvent): void {
            this.updatePipesFromStomp(flexEvent);

        }

        private dropMessageReceived(flexEvent: Models.IFlexEvent): void {
            this.updatePipesFromStomp(flexEvent);
        }

        private containsStreamPipe(streamPipeId: number): boolean {
           return this.selectedConnectionRoom.pipes.some((pipe: Models.IPipe) => {
                return pipe.destinations.some((dest: Models.IDestination) => {
                    if (dest.streamPipeHref) {
                        if (Common.Utils.idFromHref(dest.streamPipeHref) === streamPipeId) {
                            return true;
                        }
                    }
                });
            });
        }

        private updatePipesFromStomp( event: Models.IFlexEvent ): void {
            let eventData: Models.IDropEventData = event.data;
            if (this.containsStreamPipe(eventData.streamPipeId)) {
                let pipe: IPipe = this.getLoadedStreamPipeById( eventData.streamPipeId );
                if (pipe) {
                    this.connectionRoomService.getPipe(pipe.href).then((newPipe: IPipe) => {
                        newPipe.connectionRoomHref = pipe.connectionRoomHref;
                        pipe = newPipe;
                    });
                }
            }

        }
    }
}
